module.exports = __webpack_public_path__ + "static/media/polytope_5_52_3_vertex_explode.f724d875.gif";